<template>
  <div class="chart-nav">
    <r-title type="subtitle-2" style="margin-bottom:8px">
      {{ $t("chart-add") }}
    </r-title>
    <ul class="chart-nav__list">
      <li v-for="item in charts.types" :key="item" class="chart-nav__item">
        <a @click="createChart(item)">
          <el-tooltip :open-delay="1000" :content="item" placement="bottom">
            <r-icon :name="item" :size="24" />
          </el-tooltip>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import { generateUUID } from "@/utils";

export default {
  data() {
    return {
      charts: {
        types: {
          basic: "basic",
          bar: "bar",
          barX: "bar-x",
          pie: "pie",
          doughnut: "doughnut",
          pieRose: "pie-rose",
          polar: "polar",
          scatter: "scatter"
        }
      }
    };
  },
  methods: {
    async createChart(chartType) {
      const chartId = generateUUID();

      let activeTab = this.$store.state.charts.activeTab.tab;
      if (!activeTab) {
        activeTab = 1;
        this.$store.commit("ADD_CHART_TAB", activeTab);
      }
      const chartsLayouts = this.$store.state.charts.chartsLayouts;
      const activeTabLayout = chartsLayouts[activeTab];
      if (activeTabLayout.length > 2) {
        activeTab = Math.max(...Object.keys(chartsLayouts)) + 1;
        this.$store.commit("ADD_CHART_TAB", activeTab);
      }
      this.$store.commit("ADD_NEW_CHART", {
        id: chartId,
        type: chartType,
        tab: activeTab
      });
      this.$store.commit("SET_ACTIVE_CHART", { i: chartId, type: chartType });

      try {
        await this.$store.dispatch("SAVE_MAIN_USER_CONFIG");
      } catch (e) {
        console.log(e);
      }
    }
  }
};
</script>

<style lang="scss">
.charts {
  .chart-nav {
    padding: 8px;
    border-radius: var(--border-radius);
    background-color: var(--bg_containers) !important;
    &__list {
      list-style: none;
      display: flex;
      border-radius: var(--border-radius);
      align-items: center;
      flex-wrap: wrap;
    }
    &__item {
      text-align: center;
      margin-right: 6px;
      padding: 6px;
      &:last-child() {
        margin-right: 0;
      }
      a {
        cursor: pointer;
        margin: auto;
        position: relative;
        display: block;
        border-radius: var(--border-radius);
        box-sizing: border-box;
        border: 1px solid;
        border-color: transparent;
      }
    }
  }
}
</style>

<i18n>
{
  "ru": {
    "chart-add": "Добавить график"
  },
  "en": {
    "chart-add": "Add new chart"
  }
}
</i18n>
